import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { TextInput, TextInputProps } from './TextInput';

export type PasswordInputProps = Omit<TextInputProps, 'type' | 'InputProps' | 'endIcon'> & {
  label: string;
};

export const PasswordInput = ({ label, ...props }: PasswordInputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextInput
      {...props}
      label={label}
      type={visible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={`${visible ? 'Hide' : 'Show'} ${label}`}
              onClick={() => setVisible(value => !value)}
              onMouseDown={event => event.preventDefault()}
              edge="end"
            >
              {visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
